export default "__VITE_ASSET__b66c680e__"